module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/3-2a50c45d2339febaca7da524177eb450.webp";